import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright   : 2019 semantics GmbH
//  Date        : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author      : Dirk Rothe, Tobias Schwarzkopf
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 161511 $
//  Purpose     : View loader component
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Local imports
import S from './index.css';
export const ViewLoader = ({ active, children })=>{
    /* used as AppLoader and BootLoader and in presentation context
   */ return /*#__PURE__*/ _jsx("div", {
        className: clsx(S.viewLoader, active ? '' : S.fadeOut),
        children: /*#__PURE__*/ _jsxs("div", {
            className: S.content,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: S.loader,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: S.spinner
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: S.inner
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: S.text,
                    children: children
                })
            ]
        })
    });
};
